import aboutus from './aboutus.css' 
import saledFlying from '../assets/Salad-flying.png'   
import mixedFruits from '../assets/mixedFruits.png'  
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';


function Aboutus(){
return (
    <>
    <div className='aboutUs'>
    <div className='aboutUsContainer'>
      <div className='aboutUsContainer-L'>
        <div className='aboutUsContainer-L__tittle'>About us</div>
        <div className='aboutUsContainer-L__text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.  </div>
        <div className='aboutUsContainer-L__button'><button><a>About us</a></button></div>
      </div>
      <div className='aboutUsContainer-R'>
        <div className='aboutUsContainer-R__imgwraper'>
          <img src = {mixedFruits} className='aboutUsContainer-R__img' />
        </div>
      </div>
    </div>
    </div>
    </>
)
}

export default Aboutus;